import { FcmTokenSchema } from '@kilat/shared';
import { createRepo } from './_base.js';

/**
 * users/{uid}/fcmTokens/{tokenId} — one row per device that turned on operator
 * push. Doc id is the sanitised token, so re-registering collapses to one row.
 * The server prunes rows FCM reports as dead; sign-out deletes this device's.
 */
export function fcmTokensRepoFor(uid: string) {
  return createRepo({
    path: `users/${uid}/fcmTokens`,
    schema: FcmTokenSchema,
    name: `users/${uid}/fcmTokens`,
  });
}
